import API from '../../../lib/commons/api'
import IWbsItemTypeRepository from '../../../domain/repository/WbsItemRepository'
import {
  WbsItemTypeObject,
  WbsItemTypeVO,
} from '../../../domain/value-object/WbsItemTypeVO'
import { EditableTicketType } from '../../../domain/entity/TicketTypeEntity'
import { BatchTicketTypeInput } from '../../../domain/repository/WbsItemRepository/types'

export default class WbsItemTypeRepository implements IWbsItemTypeRepository {
  async getWbsItemTypes(projectUuid: string): Promise<WbsItemTypeVO[]> {
    const response = await API.functional.request(
      'GET',
      '/api/v1/projects/wbs_item_types',
      { projectUuid }
    )
    return (response.json as WbsItemTypeObject[]).map(v => new WbsItemTypeVO(v))
  }
  async getTicketTypes(projectUuid: string): Promise<WbsItemTypeVO[]> {
    const response = await API.functional.request(
      'GET',
      '/api/v1/projects/wbs_item_types/tickets',
      { projectUuid }
    )
    return (response.json as WbsItemTypeObject[]).map(v => new WbsItemTypeVO(v))
  }

  async getEditableTickets(): Promise<EditableTicketType[]> {
    const response = await API.functional.request(
      'GET',
      '/api/v1/projects/wbs_item_types/editable_tickets'
    )
    return response.json as EditableTicketType[]
  }

  async batchUpdateEditableTickets(
    payload: BatchTicketTypeInput
  ): Promise<void> {
    await API.functional.request(
      'POST',
      '/api/v1/projects/wbs_item_types/editable_tickets/batch',
      payload
    )
  }
}
